<template>
  <div class="driverList" style="height: 100%">
    <b-row>
      <b-col cols="9">
        <h1 class="panel-title">Drivers</h1>
      </b-col>
    </b-row>
    <b-row style="padding: 0 20px" align-h="end">
      <b-col cols="12" md="6" lg="3">
        <b-input-group class="mt-10">
          <b-form-input
            size="sm"
            class="mr-1"
            v-model="searchText"
            placeholder="Search Drivers.."
            @update="searchClick"
            @keyup.enter="searchClick"
          ></b-form-input>
          <b-button
            variant="primary"
            class="mr-10"
            size="sm"
            @click="searchClick"
          >
            <font-awesome-icon icon="search" />
          </b-button>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row style="padding: 20px">
      <b-col cols="12" md="4" lg="2">
        <b-form-group label="Online Status:" label-size="sm">
          <b-form-select
            size="sm"
            id="onlineStatusFilter"
            v-model="filters.onlineStatus"
            :options="filterList_onlineStatus"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" lg="2">
        <b-form-group label="State:" label-size="sm">
          <b-form-select
            size="sm"
            id="stateFilter"
            v-model="filters.state"
            :options="filterList_state"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" lg="2">
        <b-form-group label="Status:" label-size="sm">
          <b-form-select
            size="sm"
            id="statusFilter"
            v-model="filters.status"
            :options="filterList_status"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" lg="2">
        <b-form-group label="Document Status:" label-size="sm">
          <b-form-select
            size="sm"
            id="documentStatusFilter"
            v-model="filters.documentStatus"
            :options="filterList_documentStatus"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="4" lg="2">
        <b-form-group label="Vehicle Status:" label-size="sm">
          <b-form-select
            size="sm"
            id="documentStatusFilter"
            v-model="filters.carStatus"
            :options="filterList_carStatus"
          ></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <listPreview
      responsive
      :displayPreview="displayPreview"
      :previewWidth="500"
      ref="listPreview"
    >
      <template v-slot:list-view-content>
        <b-row>
          <b-col cols="12" :style="{ height: '100%' }">
            <div max-height="100%">
              <b-table
                responsive
                stacked="md"
                :hover="true"
                :items="drivers"
                :fields="driverFields"
                :no-local-sorting="true"
                @sort-changed="sortingChanged"
                @row-clicked="openModal"
                tbody-tr-class="tr-hover"
                scrollable
              >
                <template #head()="data">
                  <span
                    ><strong>{{ data.label }}</strong></span
                  >
                </template>
                <template v-slot:cell(profilePictureUrl)="data">
                  <b-avatar
                    :id="`onlineStatus_${data.item._id}`"
                    badge
                    :badge-variant="
                      data.item.onlineStatus === 'Online'
                        ? 'success'
                        : 'secondary'
                    "
                    size="70px"
                    badge-top
                    badge-offset="-0.01em"
                    :src="data.item.profilePictureUrl"
                  >
                  </b-avatar>
                  <b-tooltip :target="`onlineStatus_${data.item._id}`">{{
                    data.item.onlineStatus
                  }}</b-tooltip>
                </template>
                <template v-slot:cell(documentStatus)="data">
                  <div>
                    <b-avatar-group size="15px">
                      <b-avatar
                        text=" "
                        class="badge-new"
                        v-if="data.value.hasPending"
                        v-b-tooltip.hover
                        title="New"
                      ></b-avatar>
                      <b-avatar
                        text=" "
                        class="badge-1w"
                        v-if="data.value.has1wExpiring"
                        v-b-tooltip.hover
                        title="Expires-within-week"
                      ></b-avatar>
                      <b-avatar
                        text=" "
                        class="badge-1m"
                        v-if="data.value.has1mExpiring"
                        v-b-tooltip.hover
                        title="Expires-within-month"
                      ></b-avatar>
                      <b-avatar
                        text=" "
                        class="badge-Expire"
                        v-if="data.value.hasExpired"
                        v-b-tooltip.hover
                        title="Expired"
                      ></b-avatar>
                    </b-avatar-group>
                  </div>
                </template>
              </b-table>
            </div>
          </b-col>
        </b-row>
      </template>
      <template v-slot:list-view-footer>
        <div :style="{ padding: '20px 20px 1px 20px' }">
          <b-row>
            <b-col cols="6" md="4">
              <span>Total records: {{pagination.total}}</span>
              <b-form-select
                  v-model="pagination.pageLimit"
                  id="perPageSelect"
                  :options="[10, 30, 50, 100]"
                  @input="pageLimitChange"
                  style="width: 60px;display:inline-block"
                ></b-form-select>
            </b-col>
            <b-col cols="12" md="4">
              <b-pagination
                v-model="pagination.page"
                :total-rows="pagination.total"
                :per-page="pagination.pageLimit"
                @change="changePage"
              ></b-pagination>
            </b-col>
          </b-row>
        </div>
      </template>
      <template v-slot:preview-header>
        <b-row>
          <b-col cols="10">
            <div :style="{ padding: '10px 0 0 10px' }">
              <h3 style="margin: 0px">{{ driverName }}</h3>
              <span style="font-size: 11px"
                ><strong>ID:</strong> {{ viewDriverId }}</span
              >
              <copyButton
                :copyText="viewDriverId"
                :style="{
                  cursor: 'pointer',
                  margin: '0 0 0 7px',
                  'font-size': '11px',
                }"
              />
            </div>
          </b-col>
          <b-col cols="2">
            <div :style="{ padding: '5px' }">
              <b-button
                size="sm"
                variant="light"
                @click="closePreview()"
                :style="{
                  'background-color': 'transparent',
                  border: 'none',
                  'box-shadow': 'none',
                }"
              >
                <font-awesome-icon icon="times" />
              </b-button>
            </div>
          </b-col>
        </b-row>
      </template>
      <template v-slot:preview-content>
        <div class="d-flex justify-content-center mb-3 m-100" v-if="loading">
          <b-spinner
            style="width: 5rem; height: 5rem"
            label="Loading Driver..."
          ></b-spinner>
        </div>
        <b-tabs v-else fill>
          <b-tab title="Details" active lazy>
            <driverDetails :driver="selectedDriver" @updated="detailsUpdated" />
          </b-tab>
          <b-tab title="Vehicles" lazy>
            <vehicles
              :driverId="viewDriverId"
              :defaultCar="selectedDriver.car"
              @updated="docCountUpdated"
            />
          </b-tab>
          <b-tab title="Documents" lazy>
            <driverDocuments :driverId="viewDriverId" :defaultCar="selectedDriver.car" @updated="docCountUpdated"/>
          </b-tab>
          <b-tab title="Remarks" lazy>
            <driverRemarks :driverId="viewDriverId" />
          </b-tab>
          <b-tab title="Reviews" lazy>
            <driverReviews
              :driverId="viewDriverId"
              :driverRating="
                typeof selectedDriver.stats !== `undefined`
                  ? parseFloat(selectedDriver.stats.avgRating.toFixed(1))
                  : 0
              "
            />
          </b-tab>
        </b-tabs>
      </template>
      <!-- <template v-slot:preview-content>
        <viewGiftcard ref="giftcardView" :giftcard="selectedGiftcard" @updated="detailsUpdated"/>
      </template> -->
    </listPreview>
  </div>
</template>

<script>
import moment from "moment";
import shebahApi from "@/services/shebah/index";
import listPreview from "@/components/listPreview";
import copyButton from "@/components/copyButton";
import driverDetails from "./driverTabs/details";
import driverReviews from "./driverTabs/reviews";
import driverRemarks from "./driverTabs/remarks";
import driverDocuments from "./driverTabs/documents/index";
import vehicles from "./driverTabs/vehicles/index";
export default {
  name: "driverList",
  components: {
    listPreview,
    copyButton,
    driverDetails,
    driverReviews,
    driverRemarks,
    driverDocuments,
    vehicles,
  },
  computed: {
    scrollBar() {
      return this.$store.getters["general/scrollbar"];
    },
    authUser() {
      return this.$store.getters["authUser/user"];
    },
  },
  watch: {
    "filters.onlineStatus": function (val) {
      switch (val) {
        case "Online":
          this.filterBy("isOnDuty", true);
          break;
        case "Offline":
          this.filterBy("isOnDuty", false);
          break;
        default:
          this.filterBy("isOnDuty", "All");
      }
    },
    "filters.state": function (val) {
      this.filterBy("profile.state", val);
    },
    "filters.status": function (val) {
      this.filterBy("status", val);
    },
    "filters.documentStatus": function (val) {
      this.filterBy(`docStatus`, val);
      // switch (val) {
      //   case "new":
      //     this.filterBy("docStatus.hasPending", true);
      //     break;
      //   case "expiring1m":
      //     this.filterBy("docStatus.has1mExpiring", true);
      //     break;
      //   case "expiring1w":
      //     this.filterBy("docStatus.has1wExpiring", true);
      //     break;
      //   case "expired":
      //     this.filterBy("docStatus.hasExpired", true);
      //     break;
      //   default:
      //     this.filterBy("docStatus", "All");
      // }
    },
    "filters.carStatus": function (val) {
      this.filterBy(`carStatus`, val);
    },
  },
  data() {
    return {
      loading: true,
      driverName: null,
      displayPreview: false,
      viewDriverId: null,
      selectedDriver: {},
      drivers: [],
      driversOriginal: [],
      pagination: {
        page: 1,
        pageLimit: 30,
      },
      searchText: "",
      sortBy: "isOnDuty",
      sortDesc: true,
      filters: {
        onlineStatus: "All",
        state: "All",
        status: "All",
        documentStatus: "All",
        filterBy: "",
        carStatus: "All"
      },
      filterList_onlineStatus: ["All", "Online", "Offline"],
      filterList_state: [
        { text: "All", value: "All" },
        { text: "Australian Capital Territory", value: "ACT" },
        { text: "New South Wales", value: "NSW" },
        { text: "Northern Territory", value: "NT" },
        { text: "Queensland", value: "QLD" },
        { text: "South Australia", value: "SA" },
        { text: "Tasmania", value: "TAS" },
        { text: "Victoria", value: "VIC" },
        { text: "Western Australia", value: "WA" },
      ],
      filterList_status: [
        { text: "All", value: "All" },
        { text: "Incomplete", value: "incomplete" },
        { text: "Pending Approval", value: "pending" },
        { text: "Active", value: "active" },
        { text: "Suspended", value: "suspended" },
        { text: "Onboarded", value: "onboarded" },
        { text: "Deleted", value: "deleted" },
        { text: "Document Expire", value: "document_expire" },
        { text: "Removed By HQ", value: "removedByHQ"}
      ],
      filterList_documentStatus: [
        { text: "Any", value: "All" },
        { text: "Awaiting approval", value: "awaiting_approval" },
        { text: "Declined", value: "declined" },
        { text: "Expires within month", value: "expiring_1_m" },
        { text: "Expires in 1 week", value: "expiring_1_w" },
        { text: "Expires in 2 weeks", value: "expiring_2_w" },
        { text: "Expired", value: "expired" },
      ],
      filterList_carStatus: [
        { text: "Any", value: "All" },
        { text: "Awaiting approval", value: "awaiting_approval" },
        { text: "Active", value: "active" },
        { text: "Inactive", value: "inactive" },
      ],
      driverFields: [
        {
          key: "profilePictureUrl",
          label: "Picture",
          sortable: true,
        },
        {
          key: "name",
          label: "Name",
          sortable: true,
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
        },
        {
          key: "suburb",
          label: "SubUrb/Postcode",
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "createdTs",
          label: "Created",

          formatter: (value, key, item) => {
            return value ? moment(value).format("DD-MM-YYYY") : "";
          },
          sortable: true,
        },
        {
          key: "rating",
          label: "Rating Average",
          class: "text-center",
        },
      ],
    };
  },
  async created() {
    this.getdrivers();
  },
  methods: {
    openPreview() {
      this.$refs.listPreview.openPreview();
    },
    closePreview() {
      //this.$refs.giftcardView.resetView();
      this.$refs.listPreview.closePreview();
    },
    addressCallback(result) {},
    pageLimitChange(val) {
      this.changePage(1);
    },
    changePage(pageNumber) {
      this.pagination.page = pageNumber;
      this.getdrivers();
    },
    async getdrivers() {
      let sortField = "";
      //if this.sortDesc== true means Descending
      if (this.sortDesc) {
        sortField = "-" + this.sortBy;
      } else {
        sortField = this.sortBy;
      }
      let drivers = {};
      if (this.filters.filterBy != "") {
        drivers = await shebahApi.api.drivers.list(
          this.pagination.page,
          this.pagination.pageLimit,
          sortField,
          this.searchText,
          this.filters.filterBy
        );
      } else {
        drivers = await shebahApi.api.drivers.list(
          this.pagination.page,
          this.pagination.pageLimit,
          sortField,
          this.searchText
        );
      }
      this.driversOriginal = drivers;
      this.drivers = this.driverFactory(this.driversOriginal.data);
      this.pagination = {
        pageCount: drivers.pageCount,
        total: drivers.total,
        page: drivers.page,
        pageLimit: drivers.pageLimit,
      };
    },
    sortingChanged(ctx) {
      this.sortBy = this.getSortByField(ctx.sortBy);
      this.sortDesc = ctx.sortDesc;
      this.getdrivers();
    },
    getSortByField(input) {
      let sortField = "";
      if (input === "profilePictureUrl") {
        sortField = "isOnDuty";
      } else if (input === "documentCounts") {
        sortField = "docStatus.uploadCount";
      } else if (input === "name") {
        sortField = "firstName";
      } else if (input === "email") {
        sortField = "email";
      } else if (input === "status") {
        //Need to change when filter by pending status
        sortField = "status";
      } else if (input === "createdTs") {
        sortField = "createdTs";
      }
      return sortField;
    },
    filterBy(fieldName, value) {
      if (this.filters.filterBy == "") {
        this.filters.filterBy = fieldName + "=" + value + "&";
      } else {
        let column = fieldName.split(".")[0];
        if (this.filters.filterBy.includes(column)) {
          let fields = this.filters.filterBy.split("&").filter((el) => {
            return el.length != 0;
          });
          const index = fields.findIndex((col) => col.includes(column));
          if (index > -1) {
            fields.splice(index, 1);
            this.filters.filterBy = fields.join("&");
          }

          if (this.filters.filterBy[this.filters.filterBy.length - 1] != "&")
            this.filters.filterBy += "&";
          if (value != "All")
            this.filters.filterBy += fieldName + "=" + value + "&";
        } else {
          if (value != "All")
            this.filters.filterBy += fieldName + "=" + value + "&";
        }
      }

      this.getdrivers();
    },
    searchClick() {
      this.pagination.page=1;
      this.getdrivers();
    },
    driverFactory(drivers) {
      let newDrivers = [];
      for (let driver of drivers) {
        newDrivers.push({
          _id: driver._id,
          profilePictureUrl: driver.profile.profilePictureUrl,
          documentStatus:
            typeof driver.docStatus !== "undefined" ? driver.docStatus : "",
          documentCounts:
            typeof driver.docStatus !== "undefined"
              ? typeof driver.docStatus.uploadCount !== "undefined"
                ? driver.docStatus.uploadCount
                : "-"
              : "-",
          onlineStatus: driver.isOnDuty ? "Online" : "Offline",
          name: driver.firstName + " " + driver.lastName,
          email: driver.email,
          suburb: (() => {
            if (typeof driver.profile !== "undefined") {
              let suburb =
                typeof driver.profile.city !== "undefined"
                  ? driver.profile.city
                  : "";
              let postcode =
                typeof driver.profile.postalCode !== "undefined"
                  ? driver.profile.postalCode
                  : "";
              return suburb + "/" + postcode;
            } else {
              return " ";
            }
          })(),
          status: (() => {
            //Need to check when implement filter
            //("pending" !== $request->input('filter_status')) ? $driver->status : (isset($pendingTs) ? $pendingTs->format('d-m-Y') : ""),
            return typeof driver.status !== "undefined" ? driver.status : "";
          })(),
          createdDate: driver.createdTs,
          createdTs:
            typeof driver.createdTs !== "undefined" ? driver.createdTs : "",
          rating:
            typeof driver.stats !== "undefined"
              ? driver.stats.avgRating.toFixed(1)
              : "-",
        });
      }
      return newDrivers;
    },
    async getDriver(id) {
      let driver = await shebahApi.api.drivers.view(id);
      return driver;
    },
    async setSelectedDriver(driverId) {
      this.selectedDriver = await this.getDriver(driverId);
      this.selectedDriver.dateOfBirth =
        this.selectedDriver.dateOfBirth != undefined
          ? moment(this.selectedDriver.dateOfBirth).format('DD-MM-YYYY')
          : "";

      this.selectedDriver.createdTs = moment(
        this.selectedDriver.createdTs
      ).format("DD-MM-YYYY HH:mm:ss");
      if (
        typeof this.selectedDriver.invitedBy !== "undefined" &&
        this.selectedDriver.invitedBy != undefined
      ) {
        this.selectedDriver.invitedBy.referralCode =
          typeof this.selectedDriver.invitedBy.referralCode !== "undefined"
            ? this.selectedDriver.invitedBy.referralCode
            : "";
      } else {
        this.selectedDriver.invitedBy = { driverId: "", referralCode: "" };
      }
    },
    async openModal(row) {
      this.loading = true;
      this.viewDriverId = row._id;
      this.driverName = row.name;
      this.$refs.listPreview.openPreview();
      await this.setSelectedDriver(row._id);
      this.loading = false;
    },
    detailsUpdated(details) {
      const driverClone = [].concat(this.drivers);
      for (let driver of driverClone) {
        if (driver._id === details._id) {
          (driver.profilePictureUrl = details.profile.profilePictureUrl),
            (driver.name = details.firstName + " " + details.lastName),
            (driver.email = details.email),
            (driver.suburb = (() => {
              if (typeof details.profile !== "undefined") {
                let suburb =
                  typeof details.profile.city !== "undefined"
                    ? details.profile.city
                    : "";
                let postcode =
                  typeof details.profile.postalCode !== "undefined"
                    ? details.profile.postalCode
                    : "";
                return suburb + "/" + postcode;
              } else {
                return " ";
              }
            })()),
            (driver.status = (() => {
              return typeof details.status !== "undefined"
                ? details.status
                : "";
            })());
        }
      }

      this.drivers = driverClone;
      this.setSelectedDriver(details._id);
    },
    docCountUpdated(details) {
      const driverClone = [].concat(this.drivers);
      for (let driver of driverClone) {
        if (driver._id === details._id) {
          driver.documentCounts = details.uploadCount;
        }
      }
      this.drivers = driverClone;
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.b-avatar .b-avatar-badge {
  min-height: 0.8em;
  min-width: 0.8em;
}
.badge-new {
  background-color: #3399ff !important;
}
.badge-1m {
  background-color: #e6e600 !important;
}
.badge-1w {
  background-color: #ff9900 !important;
}
.badge-Expire {
  background-color: #ff3300 !important;
}
.activeTab {
  animation: mymove 3s infinite;
}
@keyframes mymove {
  50% {
    font-weight: bold;
    color: blue;
  }
}
.documentTab {
  margin-top: 2%;
  padding: 0%;
}
</style>
